const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const GET_VALIDATEORDER = 'GET_VALIDATEORDER';
const GET_EXPRESS_CHECKOUT_DETAILS = 'GET_EXPRESS_CHECKOUT_DETAILS';
const VALIDATED_HOLD_ORDER = 'VALIDATED_HOLD_ORDER';
const UPDATE_VALIDATE_ORDER = 'UPDATE_VALIDATE_ORDER';
const RESET_ORDER_STATUS = 'RESET_ORDER_STATUS';
const TRIGGER_CREDIT_STATUS_LANDED = 'TRIGGER_CREDIT_STATUS_LANDED';
const CREDIT_STATUS_LANDED = 'CREDIT_STATUS_LANDED';
const RUN_CREDIT_REVIEW_SUCCESS = 'RUN_CREDIT_REVIEW_SUCCESS';
const RUN_CREDIT_REVIEW_SUCCESS_DATA = 'RUN_CREDIT_REVIEW_SUCCESS_DATA';
const RESUBMIT_CREDIT_FAILED = 'RESUBMIT_CREDIT_FAILED';
const CEF_CREDIT_STATUS_ERROR = 'CEF_CREDIT_STATUS_ERROR';
const CREDIT_HOLD_STATUS = 'CREDIT_HOLD_STATUS';

export {
  GET_DATA_FROM_API,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_DATA_SUCCESS,
  ERR_OCCURED,
  GET_VALIDATEORDER,
  VALIDATED_HOLD_ORDER,
  UPDATE_VALIDATE_ORDER,
  RESET_ORDER_STATUS,
  TRIGGER_CREDIT_STATUS_LANDED,
  CREDIT_STATUS_LANDED,
  RUN_CREDIT_REVIEW_SUCCESS,
  RUN_CREDIT_REVIEW_SUCCESS_DATA,
  RESUBMIT_CREDIT_FAILED,
  CREDIT_HOLD_STATUS,
  CEF_CREDIT_STATUS_ERROR,
  GET_EXPRESS_CHECKOUT_DETAILS,
};
